import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminProfile, getUserProfile } from '../../store/slices/authSlice';

const AuthWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, isLoading, isAdmin, admin, user } = useSelector((state) => state.auth);
  
  const token = localStorage.getItem('accessToken');
  const isAdminAuth = localStorage.getItem('isAdminAuthenticated') === 'true';
  const adminData = localStorage.getItem('admin');
  const userData = localStorage.getItem('user');

  useEffect(() => {
    // If we have token and are not authenticated, try to restore session
    if (token && !isAuthenticated && !isLoading) {
      // Check if it's an admin session
      if (isAdminAuth && adminData) {
        dispatch(getAdminProfile());
      } 
      // Check if it's a user session
      else if (userData && !isAdminAuth) {
        dispatch(getUserProfile());
      }
    }
  }, [token, isAuthenticated, isLoading, isAdminAuth, adminData, userData, dispatch]);

  return <>{children}</>;
};

export default AuthWrapper;